import { makeTheme } from '@theme-ui/css/utils'

// add colors, fonts, fontSizes, space, etc
const theme = makeTheme({})

export default theme
